import { render, staticRenderFns } from "./variants.vue?vue&type=template&id=7dc5fee4&scoped=true&"
import script from "./variants.vue?vue&type=script&lang=js&"
export * from "./variants.vue?vue&type=script&lang=js&"
import style0 from "./variants.vue?vue&type=style&index=0&id=7dc5fee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc5fee4",
  null
  
)

export default component.exports